/* eslint-disable no-loop-func */
import "bootstrap/dist/css/bootstrap.min.css";
import { useState, useEffect, useMemo } from "react";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import ReactPaginate from "react-paginate";

const authUrl = process.env.REACT_APP_API_ENDPOINT_AUTH;
const jobsUrl = process.env.REACT_APP_API_ENDPOINT_JOBS;
const clientId = process.env.REACT_APP_API_CLIENT_ID;
const secret = process.env.REACT_APP_API_SECRET;

function App() {
  const [showLoader, setShowLoader] = useState(false);
  const [jobs, setJobs] = useState([]);
  const [jobPositionCity, setJobPositionCity] = useState([]);
  const [selectedCityId, setSelectedCityId] = useState("");
  const [jobPositionTitle, setJobPositionTitle] = useState([]);
  const [selectedTitleId, setSelectedTitleId] = useState("");
  const [showMenu, setShowMenu] = useState(false);

  // paginação vagas efetivas
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 5;
  const [itemOffsetEffectiveJobs, setItemOffsetEffectiveJobs] = useState(0);
  // const [currentPage, setCurrentPage] = useState(0);

  const endOffsetEffectiveJobs = itemOffsetEffectiveJobs + itemsPerPage;

  const filteredJobs = useMemo(() => {
    return jobs.filter((job) => {
      const matchesCity =
        !selectedCityId || job.cityId === Number(selectedCityId);

      const matchesTitle =
        !selectedTitleId || job.titlePositionId === Number(selectedTitleId);

      return matchesCity && matchesTitle;
    });
  }, [jobs, selectedCityId, selectedTitleId]);

  const currentEffectiveJobs = filteredJobs.slice(
    itemOffsetEffectiveJobs,
    endOffsetEffectiveJobs,
  );
  const pageCountEffectiveJobs = Math.ceil(filteredJobs.length / itemsPerPage);

  const handlePageClickEffectiveJobs = (event) => {
    const newOffset = (event.selected * itemsPerPage) % filteredJobs.length;
    setItemOffsetEffectiveJobs(newOffset);
    setCurrentPage(event.selected);

    document.getElementById("oportunidades").scrollIntoView();
  };

  const generateNonce = () => {
    const nonce = Math.floor(Math.random() * 1000000000);
    return nonce;
  };

  const generateTimestamp = () => {
    const timestamp = Math.floor(Date.now() / 1000).toString();
    return timestamp;
  };

  const onChangeFilterJobsCity = ($event) => {
    setItemOffsetEffectiveJobs(0);
    setCurrentPage(0);

    setSelectedCityId($event.target.value);
  };

  const onChangeFilterJobsTitle = ($event) => {
    setItemOffsetEffectiveJobs(0);
    setCurrentPage(0);

    setSelectedTitleId($event.target.value);
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoader(true);

      let retries = 0;
      let success = false;

      while (retries <= 2 && !success) {
        try {
          let token = localStorage.getItem("api_token");
          let storedNonce =
            localStorage.getItem("api_nonce") || generateNonce();
          let storedTimestamp =
            localStorage.getItem("api_timestamp") || generateTimestamp();

          if (!token) {
            const authResponse = await fetch(`${authUrl}`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-Nonce": storedNonce,
                "X-Timestamp": storedTimestamp,
              },
              body: JSON.stringify({
                clientId: clientId,
                secret: secret,
              }),
            });

            if (!authResponse.ok) throw new Error("Erro na autenticação");

            const authData = await authResponse.json();
            token = authData.token;

            localStorage.setItem("api_token", token);
            localStorage.setItem("api_nonce", storedNonce);
            localStorage.setItem("api_timestamp", storedTimestamp);
          }

          const dataResponse = await fetch(`${jobsUrl}`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
              "X-Target": "longping",
              "X-Nonce": storedNonce,
              "X-Timestamp": storedTimestamp,
            },
          });

          if (dataResponse.status === 401) {
            localStorage.clear();

            retries++;
            continue;
          }

          if (!dataResponse.ok) throw new Error("Erro ao buscar dados");

          const jobsData = await dataResponse.json();

          setJobs(jobsData.jobPositionList);
          setJobPositionCity(jobsData.cityList);
          setJobPositionTitle(jobsData.titlePositionList);

          success = true;
        } catch (error) {
          console.error("Erro no fluxo:", error);
          retries++;
        }
      }

      setShowLoader(false);
    };

    fetchData();
  }, []);

  return (
    <div>
      <nav className="bg-[#0F1941] h-25">
        <div className="flex items-center justify-between py-4 pr-[7%] pl-[3%] relative max-[768px]:justify-center">
          <div>
            <img
              src="./assets/icons/randstad-logo.png"
              alt="LongPing Landing Page Logo"
              className="h-26"
            />
          </div>

          <ul
            id="content-burger-menu"
            className={`${"flex flex-row justify-end items-center gap-16 list-meu w-1/2 mb-0"} ${
              showMenu ? "show" : ""
            }`}
          >
            <li>
              <a href="#sobre" className="text-white">
                sobre nós
              </a>
            </li>
            <li>
              <a href="#oportunidades" className="text-white">
                oportunidades
              </a>
            </li>
            <li>
              <a
                href="https://www.randstad.com.br/contate-nos/contato-candidato/"
                target="_blank"
                className="text-white"
                rel="noreferrer"
              >
                contato
              </a>
            </li>
          </ul>
        </div>
      </nav>

      <div className="w-full bg-[#2074D9] flex justify-center items-center max-[768px]:flex-col-reverse">
        <div
          id="main-title"
          className="flex flex-col z-10 w-1/2 gap-8 max-[768px]:w-full max-[768px]:gap-2"
        >
          <div>
            <p className="text-white ml-[5%] text-[5vw] mb-0 leading-none max-[768px]:text-[10vw]">
              venha fazer parte
            </p>
            <p className="text-white text-[5vw] ml-[14%] mb-0 leading-none max-[768px]:text-[10vw]">
              da nossa equipe!
            </p>
          </div>
          <div className="w-full flex justify-center mt-5 mb-[30px]">
            <img
              src="./assets/images/logo-longping.svg"
              alt="LongPing Landing Page"
              className="w-[50%] rounded-none max-[768px]:w-[80%]"
            />
          </div>
        </div>
        <div className="w-1/2 max-[768px]:w-full flex justify-center">
          <img
            src="./assets/images/bg-main-longping.png"
            alt="LongPing Landing Page"
            className="w-full rounded-none max-[768px]:hidden"
          />
          <img
            src="./assets/images/bg-mobile.png"
            alt="LongPing Landing Page"
            className="w-full rounded-none min-[768px]:hidden"
          />
        </div>
      </div>

      <div className="flex flex-wrap w-full bg-white py-14 px-[7vw]">
        <h1 className="text-4xl text-blue-500 font-light mb-6 max-[768px]:text-center">
          parceria LongPing e Randstad
        </h1>
        <div
          id="parceria"
          className="w-full flex flex-col gap-6 max-[768px]:flex-col"
        >
          <div className="w-full flex max-[768px]:w-full justify-center">
            <p className="text-black text-lg text-left">
              A LongPing, em parceria com a Randstad, líder global em
              recrutamento e soluções de recursos humanos, presente em mais de
              39 países pelo mundo, uniu forças para garantir um processo
              seletivo que além de selecionar talentos temporários, também
              apresente como é trabalhar em uma instituição de pesquisa agrícola
              e pioneira no desenvolvimento de arroz híbrido de alto rendimento.
            </p>
          </div>
          <div className="flex items-center justify-evenly w-full max-[768px]:w-full max-[768px]:flex-col max-[768px]:gap-10">
            <img
              src="./assets/images/logo-longping.svg"
              alt="Logo Honda"
              className="w-[30%] max-[768px]:w-[80%]"
            />
            <img
              src="./assets/images/logo-randstad.svg"
              alt="Logo Randstad"
              className="w-[20%] max-[768px]:w-[60%]"
            />
          </div>
        </div>
      </div>

      <div
        className="flex w-full gap-6 pb-14 px-[7vw] max-[768px]:flex-col justify-center"
        id="sobre"
      >
        <div className="flex flex-col w-[60%] max-[768px]:w-full">
          <h1 className="text-4xl font-light text-blue-500 mb-4 max-[768px]:text-center">
            sobre a LongPing
          </h1>
          <p className="text-lg text-black">
            A LongPing High-Tech, também conhecida como Yuan Longping High-Tech
            Agriculture Co. Ltd. é uma empresa chinesa de biotecnologia agrícola
            fundada em 1999. Seu nome é uma homenagem ao renomado cientista
            chinês Yuan Longping, conhecido como o "Pai do Arroz Híbrido",
            devido às suas contribuições significativas para o desenvolvimento
            de variedades de arroz híbridas de alto rendimento.
            <br />
            <br />
            A empresa tem suas raízes na pesquisa e desenvolvimento agrícola,
            especialmente no aprimoramento de sementes e culturas, por meio de
            tecnologias de melhoramento genético. A LongPing High-Tech foi uma
            das primeiras empresas a se envolver de maneira significativa na
            produção e comercialização de sementes híbridas de alto rendimento
            na China.
            <br />
            <br />
            Ao longo dos anos, a LongPing High-Tech concentrou-se na pesquisa,
            produção e venda de sementes de alta qualidade e tecnologicamente
            avançadas, abrangendo várias culturas agrícolas, como arroz, milho,
            sorgo e vegetais. A empresa se destacou no desenvolvimento de
            sementes híbridas que oferecem maior produtividade, resistência a
            doenças e outras características desejáveis.
          </p>
          <a href="#oportunidades" className="w-[350px] max-[768px]:w-full">
            <button className="bg-[#2074D9] text-white w-full h-[60px] rounded-sm hover:bg-blue-600 max-[768px]:w-full">
              Clique aqui e confira nossas vagas
            </button>
          </a>
        </div>

        <div className="w-[40%] h-auto max-[768px]:w-full">
          <img
            src="./assets/images/landing-image-5.png"
            alt="LongPing Landing Page"
            className="w-full"
          />
        </div>
      </div>

      <div
        className="flex w-full gap-6 py-14 px-[7vw] max-[768px]:flex-col-reverse justify-center"
        id="missao"
      >
        <div className="w-[40%] h-auto max-[768px]:w-full">
          <img
            src="./assets/images/landing-image-6.png"
            alt="LongPing Landing Page"
            className="w-full"
          />
        </div>
        <div className="flex flex-col w-[60%] max-[768px]:w-full">
          <h1 className="text-4xl font-light text-blue-500 mb-4 max-[768px]:text-center">
            missão LongPing
          </h1>
          <p className="text-lg text-black">
            O compromisso da LongPing vai além de apenas fornecer sementes de
            alta tecnologia. Estão firmemente empenhados em oferecer sementes
            que incorporam o estado da arte em termos de inovação e avanços
            científicos. Com um compromisso inabalável, a empresa possui
            agilidade e excelência em todos os aspectos do trabalho, buscando
            não apenas atender, mas superar as expectativas dos parceiros e
            clientes.
            <br />
            <br />
            Fortalecer relacionamentos é parte integral da missão da empresa,
            pois eles acreditam que o sucesso mútuo se constrói sobre a
            confiança, o respeito e a colaboração contínua. Comunica-se de
            maneira aberta e transparente, priorizando as necessidades e desejos
            dos parceiros.
            <br />
            <br />
            “Ao desempenhar o papel na cadeia alimentar global, não apenas
            contribuímos para a alimentação da humanidade, mas também entendemos
            a responsabilidade em garantir a sustentabilidade e a qualidade do
            suprimento alimentar. Reconhecendo o impacto das ações e, portanto,
            buscando soluções inovadoras e ambientalmente conscientes.”
          </p>
        </div>
      </div>

      <div className="w-full flex flex-col justify-center px-[7vw] pb-14">
        <h1 className="text-4xl font-light text-blue-500 mb-4 max-[768px]:text-center">
          alguns diferenciais
        </h1>
        <p className="text-lg text-black">
          Alguns benefícios que você terá trabalhando na LongPing através da
          Randstad:
        </p>
        <ul className="list-disc ml-6">
          <li>Sálario</li>
          <li>Alimentação no local</li>
          <li>Transporte fretado</li>
        </ul>
      </div>

      <div className="w-full flex flex-col justify-center px-[7vw]">
        <h1 className="text-4xl font-light text-blue-500 mb-4 max-[768px]:text-center">
          toda história tem um bom começo!
        </h1>
        <p className="text-lg text-black">
          Foi assim que a Randstad surgiu: de uma grande ideia, através de uma
          bicicleta.
          <br />
          <br />
          Foi de bike que nosso fundador, lá na Holanda em 1960, levou a
          primeira candidata à sua entrevista de emprego. Hoje, a Randstad é
          líder global em recrutamento e soluções de recursos humanos.
          <br />
          <br />
          Nosso propósito é apoiar o maior número possível de pessoas a alcançar
          seu verdadeiro potencial ao longo de suas vidas profissionais. E temos
          a ambição de ser a empresa de talentos mais equitativa e especializada
          do mundo.
        </p>
      </div>

      <div
        className="w-full flex flex-col justify-center py-14 px-[7vw]"
        id="oportunidades"
      >
        <h1 className="text-4xl font-light text-blue-500 mb-4 max-[768px]:text-center">
          quer uma oportunidade? então faça sua inscrição!
        </h1>

        <div className="flex max-lg:flex-col justify-between max-lg:gap-4 w-full">
          <select
            onChange={onChangeFilterJobsCity}
            defaultValue=""
            className="max-lg:w-full filter-btn w-[350px] mb-4 p-2 cursor-pointer"
          >
            <option value="">Todas as cidades</option>
            {jobPositionCity.map((jobId, i) => (
              <option value={jobId.id} key={i}>
                {jobId.name} {jobId.stateCode ? `- ${jobId.stateCode}` : ""}
              </option>
            ))}
          </select>
          <select
            onChange={onChangeFilterJobsTitle}
            defaultValue=""
            className="max-lg:w-full filter-btn w-[350px] mb-4 p-2 cursor-pointer"
          >
            <option value="">Todas os cargos</option>
            {jobPositionTitle.map((jobId, i) => (
              <option value={jobId.id} key={i}>
                {jobId.name}
              </option>
            ))}
          </select>
        </div>

        {showLoader && (
          <div className="w-full flex flex-col items-center mt-20 max-[768px]:w-full">
            <Spinner animation="grow" variant="primary" />
            <h4 className="text-[#3b82f6] mt-4">Carregando</h4>
          </div>
        )}
        {!showLoader && currentEffectiveJobs.length ? (
          <>
            <ul>
              {currentEffectiveJobs.map((job, i) => (
                <li className="jobs-list" key={i}>
                  <div className="w-[70%] pl-3 max-[768px]:w-full max-[768px]:p-0">
                    <p className="!m-0 max-[768px]:text-center">{job.name}</p>
                  </div>
                  <div className="w-[30%] flex justify-end max-[768px]:w-full max-[768px]:justify-center">
                    <Button
                      className="py-3 px-5 cursor-pointer self-end"
                      variant="primary"
                      href={job.shortUrl}
                      target="_blank"
                    >
                      candidatar-se
                    </Button>
                  </div>
                </li>
              ))}
            </ul>
            <ReactPaginate
              containerClassName="pagination"
              breakLabel="..."
              nextLabel="Próximo >"
              onPageChange={handlePageClickEffectiveJobs}
              marginPagesDisplayed={2}
              pageCount={pageCountEffectiveJobs}
              forcePage={currentPage}
              previousLabel="< Anterior"
              renderOnZeroPageCount={null}
            />
          </>
        ) : null}

        {!showLoader && !currentEffectiveJobs.length ? (
          <div className="jobs-list justify-center">
            <h2 className="text-blue-500 text-xl">
              Não encontramos resultados para sua busca.
            </h2>
          </div>
        ) : null}
      </div>

      <div className="bg-[#f7f5f0] px-[7vw] py-12">
        <p className="text-black text-2xl mb-8">
          Buscando dicas para a sua carreira? Confira nosso blog
        </p>
        <a
          href="https://www.randstad.com.br/guia-carreira/"
          target="_blank"
          className="border border-blue-500 text-blue-500 py-3 px-6 rounded-sm hover:bg-blue-500 hover:text-white transition"
          rel="noreferrer"
        >
          acesse nosso blog
        </a>
      </div>

      <footer className="bg-[#2074D9] text-white py-8">
        <div className="container mx-auto flex flex-col items-center md:flex-row md:justify-between px-4">
          <div className="mb-4 md:mb-0">
            <img
              src="./assets/icons/Logo.png"
              alt="Randstad Logo"
              className="h-12"
            />
          </div>

          <div className="text-center md:text-left mb-4 md:mb-0">
            <p className="mb-2">
              Randstad Brasil Recursos Humanos LTDA é uma empresa registrada no
              Brasil sob CNPJ 03.573.863/000
            </p>
            <p>
              Escritório da matriz encontra-se na Av. Francisco Matarazzo, 1350,
              20º andar / CEP: 05001-100
            </p>
            <p>
              A Randstad trata dados pessoais de acordo com a LGPD (Lei
              13.709/18). Leia nosso{" "}
              <a
                href="https://www.randstad.com.br/sobre-sua-privacidade/"
                target="_blank"
                className="text-white underline hover:no-underline"
                rel="noreferrer"
              >
                Aviso de Privacidade
              </a>
              .
            </p>
          </div>

          <div className="flex space-x-4">
            <a
              href="https://www.linkedin.com/company/randstad-brasil/"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img src="./assets/icons/linkedin-logo.png" alt="Linkedin Logo" />
            </a>
            <a
              href="https://www.youtube.com/user/randstadbrasil/featured"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img src="./assets/icons/youtube-logo.png" alt="Youtube Logo" />
            </a>
            <a
              href="https://www.facebook.com/RandstadBR/"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img src="./assets/icons/facebook-logo.png" alt="Facebook Logo" />
            </a>
            <a
              href="https://www.instagram.com/randstadbr/"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img
                src="./assets/icons/instagram-logo.png"
                alt="Instagram Logo"
              />
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
